import React from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { useDispatch } from "react-redux"
import { clearAllFilters } from "store/trips"
import { useTranslation } from "react-i18next"

import styles from "./ClearFiltersButton.module.css"

const ClearFiltersButton = ({ className }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  
  const buttonClassName = className 
    ? `${styles.clearFiltersBtn} ${className}` 
    : styles.clearFiltersBtn
  
  return (
    <Button
      type="link"
      shape="round"
      className={buttonClassName}
      onClick={() => dispatch(clearAllFilters())}
    >
      {t("filterTags.clear_all_filters")}
    </Button>
  )
}

ClearFiltersButton.propTypes = {
  className: PropTypes.string
}

export default ClearFiltersButton
